// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/aerolinea-flights/list',
    name: 'aerolinea-flights-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/flights/Aerolineas.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_aerolines',
    },
  },
  {
    path: '/aerolinea-flights/update',
    name: 'aerolinea-flights-update',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/flights/form/Aerolineas.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_aerolines',
    },
  },
]

export default formTable
